import { useRecoilValue } from "recoil";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { SampleMethodology } from "../../../Component/Model/Dto/VerificationAgency/SampleMethodology";
import { VAElements } from "../../../Component/Model/Enum/BEE123Enums";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { DateFormatter, removeHtmlformat } from "../../../Component/Model/helpers";
import { UserAtom } from "../../../State/user.Atom";

interface sampleMethodologiesTableRow {
    element: string;
    policyDetail: string;
    sampleLow: number;
    sampleMedium: number;
    sampleHigh: number;
    sampleInterview: number;
    modifiedDateUtc: string;
    modifiedBy: string;
    actions: ActionType[];
}

export interface ISampleMethodologiesTable {
    columns: Array<TableColumn>;
    rows: Array<sampleMethodologiesTableRow>;
}
export function SampleMethodologiesTableMapper(results: SampleMethodology.SampleMethodologyData[], editMethodology: (selectedSampleMethodologyId: string) => void, clearMethodology: (selectedSampleMethodologyId: number) => void): ISampleMethodologiesTable {
    const columns = [
        { Header: 'Element', accessor: 'element', Cell: ({ value }: any) => <DefaultCell value={value}/>},
        { Header: 'Policy Detail', accessor: 'policyDetail', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="500px"/> },
        { Header: 'Sample Low', accessor: 'sampleLow', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Sample Medium', accessor: 'sampleMedium', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Sample High', accessor: 'sampleHigh', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Interview Sample Size', accessor: 'sampleInterview', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Last Edited', accessor: 'modifiedDateUtc', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Last Edited By', accessor: 'modifiedBy', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];

    const user = useRecoilValue(UserAtom);

    if (results.length >= 0) {
        const rows = results.map((item: SampleMethodology.SampleMethodologyData, index: number) => {
            const actions = [
                {
                    key: index.toString(),
                    label: 'Edit',
                    action: () => {
                        editMethodology(item.id);
                    },
                    icon: {
                        color: 'primary',
                        name: 'edit'
                    }
                }
            ];

            if (user.isAdmin) {
                actions.push({
                    key: index.toString(),
                    label: 'Clear',
                    action: () => {
                        clearMethodology(item.elementId);
                    },
                    icon: {
                        color: 'error',
                        name: 'clear'
                    }
                });
            }
            
            return {
                id: item.id,
                element: VAElements[item.elementId],
                policyDetail: item.policyDetail.length > 40 ? removeHtmlformat(item.policyDetail).substring(0, 40) + "..." : removeHtmlformat(item.policyDetail),
                sampleLow: item.sampleLow,
                sampleMedium: item.sampleMedium,
                sampleHigh: item.sampleHigh,
                sampleInterview: item.sampleInterview,
                modifiedDateUtc: item.lastModifiedDateUtc ? DateFormatter(item.lastModifiedDateUtc.toString()) : '',
                modifiedBy: item.lastModifiedBy,
                actions: actions
            };
        });
        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}